import React from 'react'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Loader from '../../common/Loader'
import { Link } from 'react-router-dom'
import EditOrderBooking from './EditOrderBooking'
import moment from 'moment'
import { write, utils } from 'xlsx'
import Button from '../../common/CustomComponents/Button'
import CustomFooter from '../../common/TableBottom'

class StoreBookings extends React.Component {
  state = {
    limit: 10,
    pageNumber: 0,
    list: [],
    isLoading: false,

    openDailog: false,
    bookingData: null,
    bookingId: null,

    status: -1,
    statusCodes: [],

    // Filter states
    storeType: '',
    orderCreatedStartDate: '',
    orderCreatedEndDate: '',
    keyword: '',
    isSearching: false,

    // Pagination states
    totalCount: 0,
    totalPages: 0,
    disabled: false,
  }

  debounceTimeout = null

  componentDidMount() {
    this.loadBookingStatus()
    this.getList()
  }

  componentWillUnmount() {
    // Clear timeout on unmount
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  loadBookingStatus = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/get-booking-status', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ statusCodes: res.data.data || [] })
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getList = async () => {
    this.setState({
      isLoading: true,
      isSearching: true,
      list: [],
    })

    await axios
      .get(Constant.getAPI() + '/store/store-orders', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          storeType: this.state.storeType,
          orderCreatedStartDate: this.state.orderCreatedStartDate,
          orderCreatedEndDate: this.state.orderCreatedEndDate,
          keyword: this.state.keyword,
          pageNumber: this.state.pageNumber,
          limit: this.state.limit,
        },
      })
      .then((res) => {
        this.setState({
          list: res.data.data || [],
          disabled: !res.data.data?.length > 0,
          totalCount: res.data.pagination?.count || 0,
          totalPages: res.data.pagination?.pages || 0,
        })
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
          isSearching: false,
        })
      })
  }

  editBooking = (id) => {
    this.setState({
      openDailog: true,
      bookingId: id,
    })
  }

  closeDailog = () => {
    this.setState({
      openDailog: false,
      bookingId: null,
    })
  }

  statusUpdate = async (data) => {
    await axios
      .post(
        Constant.getAPI() + '/store/update-order-status',
        {
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then(() => {
        Swal.fire('Updated !', 'Booking has been Updated', 'success')
        this.closeDailog()
        this.getList()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    event.persist()
    const fieldName = event?.target?.name
    const fieldValue = event?.target?.value

    this.setState({
      [fieldName]: fieldValue,
    })

    // Auto-search with debounce for all filters except keyword
    if (fieldName !== 'keyword') {
      this.triggerAutoSearch()
    } else {
      // Debounce keyword search
      this.triggerDebouncedSearch()
    }
  }

  searchData = async () => {
    this.setState(
      {
        pageNumber: 0,
      },
      () => {
        this.getList()
      }
    )
  }

  clearFilters = () => {
    // Clear any pending debounce
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    this.setState(
      {
        storeType: '',
        orderCreatedStartDate: '',
        orderCreatedEndDate: '',
        keyword: '',
        list: [],
        pageNumber: 0,
        limit: 10,
      },
      () => {
        // Auto-fetch data after clearing filters
        this.getList()
      }
    )
  }

  triggerDebouncedSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for keyword search (500ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          pageNumber: 0,
        },
        () => {
          this.getList()
        }
      )
    }, 500)
  }

  triggerAutoSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for filter changes (300ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          pageNumber: 0,
        },
        () => {
          this.getList()
        }
      )
    }, 300)
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: 'order_number',
        label: 'Order ID',
        options: {
          filter: true,
          sort: false,
        },
      },
      {
        name: 'customer_name',
        label: 'Customer Name',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value) => {
            return <span>{value}</span>
          },
        },
      },
      {
        name: 'customer_number',
        label: 'Customer Number',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value) => {
            return <span>{value}</span>
          },
        },
      },
      {
        name: 'store_name',
        label: 'Store Name',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value) => {
            return <span>{value}</span>
          },
        },
      },
      {
        name: 'order_date',
        label: 'Order Placed Time',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            return <div>{value}</div>
          },
        },
      },
      {
        name: 'expected_delivery_datetime',
        label: 'Delivery Date',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (date) => {
            return date ? <div>{moment.utc(date).format('DD/MM/YYYY hh:mm A')}</div> : '--'
          },
        },
      },
      {
        name: 'delivery_area',
        label: 'Delivery Area',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (data) => {
            return data || '--'
          },
        },
      },
      {
        name: 'booking_amount',
        label: 'Order Amount',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (data) => {
            return data || '--'
          },
        },
      },
      {
        name: 'delivery_charge',
        label: 'Delivery Charge',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (data) => {
            return data || '--'
          },
        },
      },
      {
        name: 'coupon_amount_applied',
        label: 'Coupon Amount Applied',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (data) => {
            return data || '--'
          },
        },
      },
      {
        name: 'wallet_amount_applied',
        label: 'Wallet Amount Applied',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (data) => {
            return data || '--'
          },
        },
      },
      {
        name: 'total_amount',
        label: 'Total order amount',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            return <div>{value || '--'}</div>
          },
        },
      },
      {
        name: 'order_status',
        label: 'Order status',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value) => {
            let status = 'PENDING'

            if (value) {
              status = value
            }

            return (
              <div>
                {status == 'CANCELLED' || status == 'PENDING' ? (
                  <span className="badge badge-pill badge-warning">{status}</span>
                ) : (
                  <span className="badge badge-pill badge-success">{status}</span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'comment',
        label: 'Comments',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            return <div>{value}</div>
          },
        },
      },
      {
        name: 'id',
        label: 'View',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={'/store-bookings-details/' + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View"
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Edit Order',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <span
                  className="pointer"
                  style={{ cursor: 'pointer' }}
                  onClick={this.editBooking.bind(this, id)}
                >
                  <i className="f-18 icofont icofont-edit"></i>
                </span>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      search: false,
      filter: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => {
            this.getList()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => {
            this.getList()
          }
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Store_Orders`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            temp[columns[idx].label] = v
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        // cancel default  CSV download from table
        return false
      },
    }

    return (
      <>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-border-default">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">Search</label>
                        <div className="col-md-9">
                          <input
                            type="text"
                            id="keyword"
                            className="form-control"
                            value={this.state.keyword}
                            name="keyword"
                            placeholder="Order No | Customer Phone/Email"
                            onKeyPress={this.handleKeyPress}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-12"
                      style={{ borderBottom: '2px solid #ddd', marginBottom: 16 }}
                    ></div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Store Type</label>
                        <div className="col-sm-9">
                          <select
                            name="storeType"
                            className="form-control"
                            value={this.state.storeType}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            <option value={'STORE'}>Store</option>
                            <option value={'CATERING'}>Catering</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">Start Date</label>
                        <div className="col-md-9">
                          <input
                            type="date"
                            id="orderCreatedStartDate"
                            className="form-control"
                            value={this.state.orderCreatedStartDate}
                            name="orderCreatedStartDate"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">End Date</label>
                        <div className="col-md-9">
                          <input
                            type="date"
                            id="orderCreatedEndDate"
                            className="form-control"
                            value={this.state.orderCreatedEndDate}
                            name="orderCreatedEndDate"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group row">
                        <div className="text-left col">
                          <Button
                            onClick={this.searchData}
                            disabled={this.state.isSearching}
                          >
                            {this.state.isSearching ? 'Searching...' : 'Search'}
                          </Button>
                          <Button
                            variant={'outlined'}
                            onClick={this.clearFilters}
                          >
                            Clear
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="dt-responsive table-responsive">
                <MUIDataTable
                  title={'Orders'}
                  className="table-responsive"
                  data={this.state.list}
                  columns={columns}
                  options={options}
                />
              </div>
            </div>
          </div>
        </div>
        {this.state.openDailog && (
          <EditOrderBooking
            orderData={this.state.list.find((ele) => ele.id === this.state.bookingId)}
            openDailog={this.state.openDailog}
            statusList={this.state.statusCodes}
            bookingId={this.state.bookingId}
            handleClose={this.closeDailog}
            handleUpdate={this.statusUpdate}
          />
        )}
      </>
    )
  }
}

export default StoreBookings
